import React from 'react';

import { createNativeStackNavigator } from '@react-navigation/native-stack';

import { AccountDetailsScreen } from '@/feature/account-details/screens/AccountDetails';
import { AccountSummaryScreen } from '@/feature/account-summary/screens/AccountSummary';
import { PlayHistoryScreen } from '@/feature/account-summary/screens/PlayHistory';
import { WalletHistoryScreen } from '@/feature/account-summary/screens/WalletHistory';
import { CasinoHistoryScreen } from '@/feature/casino-history/screens/CasinoHistoryScreen';
import { PreferencesScreen } from '@/feature/preferences/screens/Preferences';
import { DepositLimitsScreen } from '@/feature/responsible-gaming/screens/DepositLimits';
import { EntryLimitsScreen } from '@/feature/responsible-gaming/screens/EntryLimits';
import { MaxSingleEntryLimitsScreen } from '@/feature/responsible-gaming/screens/MaxSingleEntryLimits';
import { RealityCheck } from '@/feature/responsible-gaming/screens/RealityCheck';
import { SelfExclusionAdd } from '@/feature/responsible-gaming/screens/SelfExclusionAdd';
import { StateLimitsScreen } from '@/feature/responsible-gaming/screens/StateLimits';
import { TimeoutScreen } from '@/feature/responsible-gaming/screens/Timeout';
import { TransactionDetailsScreen } from '@/feature/transactions/screens/TransactionDetails';
import { TransactionHistoryScreen } from '@/feature/transactions/screens/TransactionHistory';
import { YearEndStatementScreen } from '@/feature/year-end-statement/screens/YearEndStatement';

import { AccountStackParamList } from '../../navigation/types';
import { LimitsHistoryScreen } from '../responsible-gaming/screens/LimitsHistory';
import { AccountScreen } from './screens/AccountScreen';
import { GamingLimitsScreen } from './screens/GamingLimits/GamingLimits';
import { HideVerticalsScreen } from './screens/GamingLimits/HideVerticals';
import { ManageDebitCards } from './screens/ManageDebitCards';
import { ManageExpiredDebitCardDetail } from './screens/ManageExpiredDebitCardDetail';
import { SecondaryWallet } from './screens/SecondaryWallet';
import { StateSelector } from './screens/StateSelector';

const Stack = createNativeStackNavigator<AccountStackParamList>();

const screenOptions = {
    headerShown: false,
};

export const AccountStackTabs = () => {
    return <AccountStackInner mode="tabs" />;
};

export const AccountStack = () => {
    return <AccountStackInner mode="stack" />;
};

const AccountStackInner = ({ mode }: { mode: 'tabs' | 'stack' }) => {
    return (
        <>
            <Stack.Navigator screenOptions={screenOptions} initialRouteName="Account">
                <Stack.Screen name="Account" component={AccountScreen} initialParams={{ mode }} />
                <Stack.Screen name="ResponsibleGaming" component={GamingLimitsScreen} />
                <Stack.Screen name="DepositLimits" component={DepositLimitsScreen} />
                <Stack.Screen name="LimitsHistory" component={LimitsHistoryScreen} />
                <Stack.Screen name="StateLimits" component={StateLimitsScreen} />
                <Stack.Screen name="EntryLimits" component={EntryLimitsScreen} />
                <Stack.Screen name="MaxSingleEntryLimits" component={MaxSingleEntryLimitsScreen} />
                <Stack.Screen name="RealityCheck" component={RealityCheck} />
                <Stack.Screen name="Timeout" component={TimeoutScreen} />
                <Stack.Screen name="HideVerticals" component={HideVerticalsScreen} />
                <Stack.Screen name="SelfExclusionAdd" component={SelfExclusionAdd} />
                <Stack.Screen name="TransactionHistory" component={TransactionHistoryScreen} />
                <Stack.Screen name="AccountDetails" component={AccountDetailsScreen} />
                <Stack.Screen name="YearEndStatement" component={YearEndStatementScreen} />
                <Stack.Screen name="AccountSummary" component={AccountSummaryScreen} />
                <Stack.Screen name="PlayHistory" component={PlayHistoryScreen} />
                <Stack.Screen name="WalletHistory" component={WalletHistoryScreen} />
                <Stack.Screen name="CasinoHistoryScreen" component={CasinoHistoryScreen} />
                <Stack.Screen name="StateSelector" component={StateSelector} />
                <Stack.Screen name="TransactionDetails" component={TransactionDetailsScreen} />
                <Stack.Screen name="Preferences" component={PreferencesScreen} />
                <Stack.Screen name="SecondaryWallet" component={SecondaryWallet} />
                <Stack.Screen
                    name="ManageDebitCards"
                    component={ManageDebitCards}
                    options={{ contentStyle: { flex: 1 } }}
                />
                <Stack.Screen name="ManageExpiredDebitCardDetail" component={ManageExpiredDebitCardDetail} />
            </Stack.Navigator>
        </>
    );
};
